<!-- Task Sidebar -->
<div class="task-sidebar-container">
    <!-- Header Section -->
    <div class="task-header">
        <div class="task-header-content">
            <div class="task-logo">
                <i class="fas fa-tasks"></i>
                <h3 class="task-title">Tasks</h3>
            </div>
        </div>
    </div>

    <!-- Task Summary Cards -->
    <div class="task-summary">
        <div class="summary-card pending">
            <div class="summary-icon">
                <i class="fas fa-clock"></i>
            </div>
            <div class="summary-content">
                <span class="summary-number">{{
                    getTasksByStatus('Not Started').length
                }}</span>
                <span class="summary-label">Not Started</span>
            </div>
        </div>

        <div class="summary-card in-progress">
            <div class="summary-icon">
                <i class="fas fa-spinner"></i>
            </div>
            <div class="summary-content">
                <span class="summary-number">{{
                    getTasksByStatus('In Progress').length
                }}</span>
                <span class="summary-label">In Progress</span>
            </div>
        </div>

        <div class="summary-card done">
            <div class="summary-icon">
                <i class="fas fa-check-circle"></i>
            </div>
            <div class="summary-content">
                <span class="summary-number">{{
                    getTasksByStatus('Done').length
                }}</span>
                <span class="summary-label">Done</span>
            </div>
        </div>
    </div>

    <!-- Task List -->
    <div class="task-list">
        <div class="task-section">
            <h4 class="section-title high-priority">
                <i class="fas fa-exclamation-triangle"></i>
                High Priority
            </h4>
            <div class="task-items">
                <div
                    *ngFor="let task of getTasksPriority(TaskPriority.High)"
                    class="task-item"
                    [class.done]="task.done"
                    [class.high-priority]="task.priority === TaskPriority.High"
                >
                    <div
                        class="task-status-select"
                        (click)="$event.stopPropagation()"
                    >
                        <select
                            [ngModel]="
                                task.statusId || getStatusIdByName(task.status)
                            "
                            (ngModelChange)="onStatusChange(task, $event)"
                        >
                            <option
                                *ngFor="let s of statusOptions"
                                [value]="s.id"
                            >
                                {{ s.name }}
                            </option>
                        </select>
                    </div>
                    <div class="task-content">
                        <div class="task-main">
                            <span class="task-name">{{ task.title }}</span>
                        </div>
                        <div class="task-details">
                            <span class="task-due">
                                <i class="fas fa-calendar"></i>
                                {{ task.dueDate }}
                            </span>
                            <span class="task-assignee">
                                <i class="fas fa-user"></i>
                                {{ task.assignedTo }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="task-section">
            <h4 class="section-title">
                <i class="fas fa-list"></i>
                All Tasks
            </h4>
            <div class="task-items">
                <div
                    *ngFor="let task of tasks"
                    class="task-item"
                    [class.done]="task.done"
                    [class]="task.priority + '-priority'"
                >
                    <div
                        class="task-status-select"
                        (click)="$event.stopPropagation()"
                    >
                        <select
                            [ngModel]="
                                task.statusId || getStatusIdByName(task.status)
                            "
                            (ngModelChange)="onStatusChange(task, $event)"
                        >
                            <option
                                *ngFor="let s of statusOptions"
                                [value]="s.id"
                            >
                                {{ s.name }}
                            </option>
                        </select>
                    </div>
                    <div class="task-content">
                        <div class="task-main">
                            <span class="task-name">{{ task.title }}</span>
                        </div>
                        <div class="task-details">
                            <span class="task-description">{{
                                task.description
                            }}</span>
                            <span class="task-due">
                                <i class="fas fa-calendar"></i>
                                {{ task.dueDate }}
                            </span>
                            <span class="task-assignee">
                                <i class="fas fa-user"></i>
                                {{ task.assignedTo }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Add New Task Button -->
    <div class="task-actions">
        <button class="add-task-btn" (click)="openAddTaskDialog()">
            <i class="fas fa-plus"></i>
            <span>Add New Task</span>
        </button>
    </div>
</div>

<!-- Add New Task Dialog -->
<p-dialog
    [(visible)]="showAddTaskDialog"
    modal="true"
    focusOnShow="false"
    [style]="{width: '1100px'}"
    [closable]="false"
    [baseZIndex]="200000"
    [appendTo]="'body'"
>
    <div class="text-left close-popup-pdialog" (click)="closeAddTaskDialog()">
        <span class="fas fa-chevron-left"></span> Back
    </div>
    <ng-template pTemplate="content">
        <app-add-task
            [visible]="showAddTaskDialog"
            (closeDialog)="closeAddTaskDialog()"
            (taskSaved)="onTaskSaved($event)"
        ></app-add-task>
    </ng-template>
</p-dialog>
